import React from 'react';
import { FormattedMessage } from 'react-intl';

export function Error() {
    return <FormattedMessage id="shared.error" defaultMessage="An error occurred." />;
}
